// ----------------------------------------------------------------------
// <copyright file="Izenda.AppGlobalConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  PROVISIONING_STATUS: {
    NOT_STARTED: 0,
    PROVISIONING: 1,
    SUCCESS: 2,
    ERROR: 3
  },
  DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
  DATE_TIME_FORMAT_WITH_TIMEZONE: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  DATE_FORMAT: 'YYYY-MM-DD',
  TIME_FORMAT: 'HH:mm:ss',
  DEFAULT_TIME_VALUE:'00:00:00',
  get DEFAULT_VALUES() {
    return {
      GLOBAL_NAME: localizer.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_GLOBAL_NAME'),
      LOCAL_NAME: localizer.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_LOCAL_NAME')
    };
  },
  LOCAL_CATEGORY_NAME: 32,
  GLOBAL_CATEGORY_NAME: 64,
  SELECTED_TENANT_COOKIE_NAME: 'selected_tenant',
  MONTHS:["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.AppGlobalConstants.js